import { createContext, useContext } from 'react';

export const OfferBuilderContext = createContext(null);
export const useOfferBuilder = () => useContext(OfferBuilderContext);
